import React from 'react'
import { DataGridContext } from '../DataGridProvider'

export const useDataGridContext = () => {
  return React.useContext(DataGridContext)
}
